import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

function Plan() {
  const [planpay, setPlanpay] = useState("monthly");
  const navigate = useNavigate();
  return (
    <>
      <div className={`navbar visible`}>
        <div className='navbar-container'>
          <div className='navbar-logo-left'>
            <Link to='' className='navbar-logo'>
              ProfixExpress
            </Link>
          </div>
          <div className='navbardd'>
            <div className='hirespent'>
              <p
                className='hirespenttt'
                onClick={() => navigate("/client/dashboard")}
              >
                Continue without membership
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className='planpagecnt'>
        <h1 className='signin_title'>
          Affordable Plan, Exceptional payment value.
        </h1>
        <div className='thespacesmall'></div>
        <p>
          Simple plans. Simple prices. Only pay for what you really need. All
          plans come with award-winning 24/7 customer support. Prices do not
          include applicable taxes.
        </p>
        <div className='thegap'></div>
        <div className='planselectpay'>
          <div className='planselitem'>
            <div
              className={`planbx ${planpay === "annually" && "plabx"}`}
              onClick={() => setPlanpay("annually")}
            ></div>
            <p className='planbxtxt'>Pay annually</p>
          </div>
          <div className='planselitem'>
            <div
              className={`planbx ${planpay === "semi-annually" && "plabx"}`}
              onClick={() => setPlanpay("semi-annually")}
            ></div>
            <p className='planbxtxt'>Pay Semi-Annually</p>
          </div>
          <div className='planselitem'>
            <div
              className={`planbx ${planpay === "quarterly" && "plabx"}`}
              onClick={() => setPlanpay("quarterly")}
            ></div>
            <p className='planbxtxt'>Pay Quarterly</p>
          </div>
          <div className='planselitem'>
            <div
              className={`planbx ${planpay === "monthly" && "plabx"}`}
              onClick={() => setPlanpay("monthly")}
            ></div>
            <p className='planbxtxt'>Pay Monthly</p>
          </div>
        </div>
        <div className='thebiggap'></div>
        <div className='plancardscnt'>
          <div className='plancardsitem'>
            <div className='plancardtop'>
              <p className='typcnt corp'>Corporate</p>
              <div className='thespacesmall'></div>
              {planpay === "monthly" && <p>₦45,999.99/Month</p>}
              {planpay === "annually" && <p>₦499,999.99/Annually</p>}
              {planpay === "semi-annually" && <p>₦255,999.99/Semi-Annually</p>}
              {planpay === "quarterly" && <p>₦131,999.99/Quarterly</p>}
              <div className='thegap'></div>
              <button
                className='selectedplan'
                onClick={() => navigate("/client/dashboard")}
              >
                SELECT
              </button>
            </div>
            <div className='thebiggap'></div>
            <div className='plancardbottom'>
              <div className='plancardbottomcnt'>
                <p className='plancardword'>
                  15 complimentary services annually, applicable to services
                  valued at up to ₦50,000 each
                </p>
              </div>
              <div className='plancardbottomcnt'>
                <p className='plancardword'>
                  Accesss exclusive pricing and discount structures.
                </p>
              </div>
              <div className='plancardbottomcnt'>
                <p className='plancardword'>
                  Enjoy expedited service and priority booking, ensuring minimal
                  disruption to your business operations.
                </p>
              </div>
              <div className='plancardbottomcnt'>
                <p className='plancardword'>
                  Benefit from a network of vetted and experienced technicians
                  specializing in a variety of handyman services.
                </p>
              </div>
              <div className='plancardbottomcnt'>
                <p className='plancardword'>
                  Tailor service plans to meet the specific needs of your
                  corporate facilities and workforce.
                </p>
              </div>
              <div className='plancardbottomcnt'>
                <p className='plancardword'>
                  Choose from various membership plans that offer predictable
                  budgeting and reduced upfront costs.
                </p>
              </div>
              <div className='plancardbottomcnt'>
                <p className='plancardword'>
                  Experience consistent, high-quality work supported by rigorous
                  service standards and quality control.
                </p>
              </div>
              <div className='plancardbottomcnt'>
                <p className='plancardword'>
                  Access to rapid response services for urgent repairs or
                  maintenance issues, reducing downtime.
                </p>
              </div>
              <div className='plancardbottomcnt'>
                <p className='plancardword'>
                  Dedicated account managers who ensure efficient service
                  coordination and personalized support.
                </p>
              </div>
              <div className='plancardbottomcnt'>
                <p className='plancardword'>
                  Leverage additional benefits like bundled services, seasonal
                  promotions, and comprehensive maintenance programs.
                </p>
              </div>
              <div className='plancardbottomcnt'>
                <p className='plancardword'>
                  Extra 5% discount when you setup automatic payment.
                </p>
              </div>
              <div className='plancardbottomcnt'>
                <p className='plancardword'>
                  Tailor service plans to fit specific needs, whether for
                  residential or corporate environments.
                </p>
              </div>
              <div className='plancardbottomcnt'>
                <p className='plancardword'>
                  Enjoy longer warranty periods and enhanced service guarantees
                  on all projects.
                </p>
              </div>
              <div className='plancardbottomcnt'>
                <p className='plancardword'>
                  These benefits are designed to optimize operational
                  efficiency, enhance workplace safety, and deliver long-term
                  value for corporate clients.
                </p>
              </div>
              <div className='plancardbottomcnt'>
                <p className='plancardword'>
                  Access special events, promotions, and early product/service
                  previews
                </p>
              </div>
              <div className='plancardbottomcnt'>
                <p className='plancardword'>
                  Free monthly property maintenance tips and webinars{" "}
                </p>
              </div>
            </div>
          </div>
          <div className='plancardsitem nahism'>
            <div className='plancardtop'>
              <p className='typcnt plati'>Platinum</p>
              <div className='thespacesmall'></div>
              {planpay === "monthly" && <p>₦17,999.99/Month</p>}
              {planpay === "annually" && <p>₦193,999.99/Annually</p>}
              {planpay === "semi-annually" && <p>₦99,999.99/Semi-Annually</p>}
              {planpay === "quarterly" && <p>₦51,999.99/Quarterly</p>}
              <div className='thegap'></div>
              <button
                className='selectedplan'
                onClick={() => navigate("/client/dashboard")}
              >
                SELECT
              </button>
            </div>
            <div className='thebiggap'></div>
            <div className='plancardbottom'>
              <div className='plancardbottomcnt'>
                <p className='plancardword'>
                  10 complimentary services annually, applicable to services
                  valued at up to N30,000 each
                </p>
              </div>
              <div className='plancardbottomcnt'>
                <p className='plancardword'>
                  Access to premium technician services
                </p>
              </div>
              <div className='plancardbottomcnt'>
                <p className='plancardword'>
                  Opportunity to purchase or receive exclusive discount vouchers
                  for family and friends
                </p>
              </div>
              <div className='plancardbottomcnt'>
                <p className='plancardword'>
                  Option to gift services to family and friends
                </p>
              </div>
              <div className='plancardbottomcnt'>
                <p className='plancardword'>
                  Priority scheduling for all service appointments
                </p>
              </div>
              <div className='plancardbottomcnt'>
                <p className='plancardword'>Same-day service availability</p>
              </div>
              <div className='plancardbottomcnt'>
                <p className='plancardword'>Waived booking fees</p>
              </div>
              <div className='plancardbottomcnt'>
                <p className='plancardword'>
                  Access to emergency services and extended working hours for
                  convenience.
                </p>
              </div>
              <div className='plancardbottomcnt'>
                <p className='plancardword'>
                  Personalized support to help manage your service requests and
                  ensure a seamless experience.
                </p>
              </div>
              <div className='plancardbottomcnt'>
                <p className='plancardword'>
                  Extra 2% discount when you setup automatic payment.
                </p>
              </div>
              <div className='plancardbottomcnt'>
                <p className='plancardword'>Shopping vouchers</p>
              </div>
            </div>
          </div>
          <div className='plancardsitem'>
            <div className='plancardtop'>
              <p className='typcnt golt'>Gold</p>
              <div className='thespacesmall'></div>
              {planpay === "monthly" && <p>₦9,999.99/Month</p>}
              {planpay === "annually" && <p>₦104,999.99/Annually</p>}
              {planpay === "semi-annually" && <p>₦55,999.99/Semi-Annually</p>}
              {planpay === "quarterly" && <p>₦28,999.99/Quarterly</p>}
              <div className='thegap'></div>
              <button
                className='selectedplan'
                onClick={() => navigate("/client/dashboard")}
              >
                SELECT
              </button>
            </div>
            <div className='thebiggap'></div>
            <div className='plancardbottom'>
              <div className='plancardbottomcnt'>
                <p className='plancardword'>
                  6 complimentary services annually, applicable to services
                  valued at up to N20,000 each
                </p>
              </div>
              <div className='plancardbottomcnt'>
                <p className='plancardword'>
                  Access to premium technician services
                </p>
              </div>
              <div className='plancardbottomcnt'>
                <p className='plancardword'>
                  Opportunity to purchase or receive exclusive discount vouchers
                  for family and friends
                </p>
              </div>
              <div className='plancardbottomcnt'>
                <p className='plancardword'>
                  Option to gift services to family and friends
                </p>
              </div>
              <div className='plancardbottomcnt'>
                <p className='plancardword'>Waived booking fees</p>
              </div>
              <div className='plancardbottomcnt'>
                <p className='plancardword'>
                  Extra 1% discount when you setup automatic payment.
                </p>
              </div>
              <div className='plancardbottomcnt'>
                <p className='plancardword'>
                  Personalized support to help manage your service requests and
                  ensure a seamless experience.
                </p>
              </div>
              <div className='plancardbottomcnt'>
                <p className='plancardword'>Same-day service availability</p>
              </div>
            </div>
          </div>
          <div className='plancardsitem'>
            <div className='plancardtop'>
              <p className='typcnt execu'>Executive</p>
              <div className='thespacesmall'></div>
              {planpay === "monthly" && <p>₦6,999.99/Month</p>}
              {planpay === "annually" && <p>₦69,999.99/Annually</p>}
              {planpay === "semi-annually" && <p>₦37,999.99/Semi-Annually</p>}
              {planpay === "quarterly" && <p>₦19,999.99/Quarterly</p>}
              <div className='thegap'></div>
              <button
                className='selectedplan'
                onClick={() => navigate("/client/dashboard")}
              >
                SELECT
              </button>
            </div>
            <div className='thebiggap'></div>
            <div className='plancardbottom'>
              <div className='plancardbottomcnt'>
                <p className='plancardword'>
                  4 complimentary services annually, applicable to services
                  valued at up to N20,000 each
                </p>
              </div>
              <div className='plancardbottomcnt'>
                <p className='plancardword'>
                  Access to premium technician services
                </p>
              </div>
              <div className='plancardbottomcnt'>
                <p className='plancardword'>
                  Opportunity to purchase or receive exclusive discount vouchers
                  for family and friends
                </p>
              </div>
              <div className='plancardbottomcnt'>
                <p className='plancardword'>
                  Option to gift services to family and friends
                </p>
              </div>
              <div className='plancardbottomcnt'>
                <p className='plancardword'>Waived booking fees</p>
              </div>
              <div className='plancardbottomcnt'>
                <p className='plancardword'>
                  Extra 1% discount when you setup automatic payment.
                </p>
              </div>
              <div className='plancardbottomcnt'>
                <p className='plancardword'>
                  Personalized support to help manage your service requests and
                  ensure a seamless experience.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Plan;
